import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { toast } from "react-toastify";
import {
  getBase2,
  patch,
  postData,
} from "modules/platform-components/api-integration-util";
import { Toaster } from "modules/platform-components/Toaster";
import { toasterMessages } from "modules/constants/QuestionBankConstants";
import { apiPaths } from "modules/platform-components/api-integration-util";

import "./App.css";
import { Box } from "@mui/material";

const currentUser = JSON.parse(localStorage.getItem("user"));

function ZoomMeeting() {
  let { id } = useParams();
  let intervalId;

  const [getData, setGetData] = useState([]);

  const iframeRef = useRef(null);

  const getLiveClasses = () => {
    getBase2(`${apiPaths.getLiveClassesById}?liveClassId=${id}`)
      .then((res) => {
        setGetData(res?.result);
      })
      .catch((ele) => {});
  };

  useEffect(() => {
    getLiveClasses();

    return () => {
      document.getElementById("meetingIframe").style.display = "none";
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateLiveClass = (data) => {
    let status = data?.status === "In Progress" ? "Completed" : "In Progress";
    postData(
      `${apiPaths.updateLiveClassStatus}?liveClassId=${data?.liveClassId}&status=${status}`
    )
      .then((res) => {
        if (res?.responseCode === 200) {
          getLiveClasses();
          Toaster(toast.TYPE.SUCCESS, toasterMessages.SUCCESS.ZOOM);
        }
      })
      .catch((e) => Toaster(toast.TYPE.ERROR, toasterMessages.FAIL.DEFAULT));
  };

  let zoomKey = getData?.zoomAPIKey;
  let meetingNumber = getData?.zoomMeetingId;
  let userName = `${currentUser?.firstName} ${currentUser?.lastName}`;
  let userEmail = currentUser?.email;
  let password = getData?.zoomMeetingPassword;
  let role = 0;
  let authEndpoint = "";

  useEffect(() => {
    if (meetingNumber) {
      getSignature();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetingNumber]);

  function getSignature() {
    postData(
      `${apiPaths.getZoomSignature}?liveClassId=${getData?.liveClassId}&meetingNumber=${meetingNumber}&role=${role}`
    )
      .then((res) => {
        console.log('res: ', res);
        const data = {
          signature: res?.result,
          sdkKey: zoomKey,
          meetingNumber: meetingNumber,
          password: password,
          userName: userName,
          userEmail: userEmail,
          tk: res?.token,
          leaveUrl: window.location.pathname,
          role: 0,
          authEndpoint: authEndpoint,
        };

        const iframe = iframeRef.current;
        iframe.onload = () => {
          getData?.status === "Scheduled" && updateLiveClass(getData);
          iframe.contentWindow.postMessage(data, "*");
        };

        window.addEventListener("message", (event) => {
          console.log('event: ', event);
          if (event.data === 'meetingEnded') {
            window.location.href = "/"
          }
        }, false);
      })
      .catch((e) => {});
  }

  return (
    <Box sx={{ height: "100vh" }}>
      <iframe
        title="Zoom Meeting"
        src={process.env.REACT_APP_ARISE_ZOOM_LINK}
        id="meetingIframe"
        ref={iframeRef}
        style={{ height: "100%", width: "100%", border: "none" }}
        allow="camera; microphone; display-capture; screen-wake-lock"
        sandbox="allow-same-origin allow-scripts"
      ></iframe>
        </Box>);
}

export default ZoomMeeting;
